<template>
    <div>
        <v-navigation-drawer
                v-if="isAppAvailable"
                v-model="drawer"
                app
                clipped>
            <v-list dense>
                <div v-for="navItem in computedNavigationItems" :key="navItem.text">
                    <v-list-item v-if="!navItem.subLinks" router :to="navItem.route">
                        <v-list-item-action>
                            <v-icon>{{navItem.icon}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{navItem.text}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group v-else :prepend-icon="navItem.icon">
                        <template v-slot:activator>
                            <v-list-item class="pl-0">
                                <v-list-item-content>
                                    <v-list-item-title>{{ navItem.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <v-list-item v-for="subLink in navItem.subLinks" :to="subLink.route" :key="subLink.text">
                            <v-list-item-title v-text="subLink.text"></v-list-item-title>
                            <v-icon>{{subLink.icon}}</v-icon>
                        </v-list-item>
                    </v-list-group>
                </div>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar
            app
            clipped-left
            dark>

            <v-app-bar-nav-icon v-if="isAppAvailable" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="hidden-xs-only">Mitarbeiterportal</v-toolbar-title>
            <v-spacer/>
            <v-tooltip bottom v-if="showMaintenanceModeIcon">
                <template v-slot:activator="{ on }">
                    <v-icon class="mr-2 pulsating" color="error" large v-on="on">mdi-hammer-wrench</v-icon>
                </template>
                <span>Achtung: Wartungsmodus ist aktiv!</span>
            </v-tooltip>
            <template v-if="isAppAvailable">
                <p class="ma-0 text-caption mr-5" v-if="isLoggedIn">
                    Sitzung läuft ab am: {{formattedSessionExpirationTime}}
                </p>

                <v-btn v-if="isLoggedIn" class="primary" text @click="logout"><v-icon>mdi-logout</v-icon>Logout</v-btn>
                <v-btn router to="/login" v-if="!isLoggedIn" text><v-icon>mdi-account-plus</v-icon>Login</v-btn>
            </template>
        </v-app-bar>
        <v-footer app dark>
            RATIS Mitarbeiterportal
            <v-spacer/>
            <v-btn small router to="/impressum" text>
                Impressum
            </v-btn>
        </v-footer>
    </div>
</template>

<script>
    import AccessLevels from "../../constants/AccessLevels";
    import { mapGetters } from 'vuex';
    import { apiLogout } from "@/api/user";
    import UserRoles from "../../constants/UserRoles";
    import {isNotNullOrUndefined} from '../../helper/shared/TypeHelper';
    import {getTokenExpirationDate} from '../../helper/shared/JWTTokenHelper';

    export default {
        name: "Navigation",
        data: () => ({
            drawer: null,
            navigationItems: [
                { icon: 'mdi-home', text: 'Startseite', route: '/', subLinks: false, accessLevel: AccessLevels.LOGGED_OUT},
                { icon: 'mdi-view-dashboard-outline', text: 'Übersicht', route: '/dashboard', subLinks: false, accessLevel: AccessLevels.LOGGED_IN},
                {
                    icon: 'mdi-briefcase',
                    text: 'Kündigung',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        // { icon: 'mdi-briefcase-outline', text: 'Übersicht', route: '/kuendigung/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-briefcase-outline', text: 'Übersicht', route: '/cancellation/overview', accessLevel: AccessLevels.LOGGED_IN },
                        // { icon: 'mdi-briefcase-plus', text: 'Neuer Fall', route: '/kuendigung/create-case', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-account-cash-outline', text: 'Übersicht Abfindungsrechner', route: '/cancellation/legacy-calculate-compensation-overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-briefcase-off-outline', text: 'Übersicht Arbeitslosmeldungen', route: '/cancellation/legacy-register-as-unemployed-overview', accessLevel: AccessLevels.LOGGED_IN },
                    ]
                },
                {
                    icon: 'mdi-airport',
                    text: 'Flüge',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-airplane', text: 'Übersicht', route: '/flights/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-shield-airplane-outline', text: 'Airlines', route: '/flights/airlines', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-wallet-travel', text: 'Allgemeines Reiserecht', route: '/flights/general-travel-overview', accessLevel: AccessLevels.LOGGED_IN },
                    ]
                },
                {
                    icon: 'mdi-car-sports',
                    text: 'Verkehr',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        // { icon: 'mdi-car-traction-control', text: 'Übersicht', route: '/transport/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-shield-car', text: 'Versicherungen', route: '/transport/insurances', accessLevel: AccessLevels.LOGGED_IN }
                    ]
                },
                {
                    icon: 'mdi-cash-multiple',
                    text: 'Vermögen',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-bank-transfer', text: 'Bankgebühren', route: '/bank-fees/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-weight-lifter', text: 'Fitnessstudiogebühren', route: '/gym-fees/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-car-arrow-left', text: 'KFZ-Widerruf', route: '/vehicle-financing/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-hook', text: 'Phishing', route: '/phishing/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-lifebuoy', text: 'Lebensversicherungen', route: '/life-insurance/overview', accessLevel: AccessLevels.LOGGED_IN }
                    ]
                },
                {
                    icon: 'mdi-fuel',
                    text: 'Abgasskandal',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-engine-outline', text: 'Übersicht', route: '/emissions/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-car-connected', text: 'Abgasskandal Widerruf', route: '/emissions/emission-compensation-overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-email-multiple', text: 'KBA-Anfragen', route: '/emissions/kba-requests', accessLevel: AccessLevels.LOGGED_IN },
                        // { icon: 'mdi-car-cog', text: 'Betroffenheitsprüfungen', route: '/emissions/emission-victim-checks', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-factory', text: 'KFZ-Hersteller', route: '/emissions/vehicle-manufacturers', accessLevel: AccessLevels.LOGGED_IN }
                        // { icon: 'mdi-car-multiple', text: 'Fahrzeuge', route: '/emissions/vehicles', accessLevel: AccessLevels.LOGGED_IN }
                    ]
                },
                {
                    icon: 'mdi-web',
                    text: 'Internetrecht',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-facebook', text: 'Facebook Datenskandal', route: '/pwned/overview', accessLevel: AccessLevels.LOGGED_IN }
                    ]
                },
                {
                    icon: 'mdi-tools',
                    text: 'Toolbox',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-file', text: 'Dokument/-e anfordern', route: '/tools/file-requester', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-file-move', text: 'Dokument/-e freigeben', route: '/tools/file-access-granter', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-account-star', text: 'Bewertungseinladung', route: '/tools/rating-invitation', accessLevel: AccessLevels.LOGGED_IN }
                    ]
                },
                {
                    icon: 'mdi-palm-tree',
                    text: 'Urlaub',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-map-search-outline', text: 'Übersicht', route: '/holiday/overview', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-calendar-outline', text: 'Urlaubskalender', route: '/holiday/calendar', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-file-move-outline', text: 'Antrag stellen', route: '/holiday/request', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-file-multiple-outline', text: 'Anträge verwalten', route: '/holiday/release', accessLevel: AccessLevels.MANAGER },
                        { icon: 'mdi-calendar-plus', text: 'Gutschriften verwalten', route: '/holiday/holiday-credits', accessLevel: AccessLevels.HUMAN_RESOURCES },
                        { icon: 'mdi-account-details-outline', text: 'Mitarbeiterübersicht', route: '/holiday/employee-overview', accessLevel: AccessLevels.HUMAN_RESOURCES },
                        { icon: 'mdi-calendar-star', text: 'Feiertage verwalten', route: '/holiday/public-holidays', accessLevel: AccessLevels.HUMAN_RESOURCES },
                    ]
                },
                {
                    icon: 'mdi-format-section',
                    text: 'Kanzlei',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-party-popper', text: 'Veranstaltungen', route: '/law-firm/events', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-cake-variant', text: 'Geburtstage', route: '/law-firm/birthdays', accessLevel: AccessLevels.LOGGED_IN },
                        { icon: 'mdi-comment-edit-outline', text: 'Feedback', route: '/law-firm/feedback', accessLevel: AccessLevels.LOGGED_IN },
                    ]
                },
                {
                    icon: 'mdi-cogs',
                    text: 'Verwaltung',
                    accessLevel: AccessLevels.LOGGED_IN,
                    subLinks: [
                        { icon: 'mdi-account-group', text: 'Benutzer', route: '/administration/users', accessLevel: AccessLevels.LOGGED_IN},
                        { icon: 'mdi-earth', text: 'Länder', route: '/administration/countries', accessLevel: AccessLevels.LOGGED_IN},
                        { icon: 'mdi-flag', text: 'Sprachen', route: '/administration/languages', accessLevel: AccessLevels.ADMIN},
                        { icon: 'mdi-shield-account', text: 'RSVs', route: '/administration/rsvs', accessLevel: AccessLevels.ADMIN},
                        { icon: 'mdi-email-alert', text: 'Erinnerungsmails', route: '/administration/reminder-mail-jobs', accessLevel: AccessLevels.ADMIN},
                        // { icon: 'mdi-alarm-check', text: 'Checkjobs', route: '/administration/check-jobs', accessLevel: AccessLevels.ADMIN},
                        { icon: 'mdi-file-clock', text: 'Eventlog', route: '/administration/event-log', accessLevel: AccessLevels.ADMIN},
                        { icon: 'mdi-hammer-wrench', text: 'Wartungsmodus', route: '/administration/maintenance-mode', accessLevel: AccessLevels.ADMIN}
                    ]
                },
                { icon: 'mdi-login', text: 'Login', subLinks: false, route: '/login', accessLevel: AccessLevels.LOGGED_OUT},
                { icon: 'mdi-lock-question', text: 'Passwort vergessen', route: '/forgot-password', subLinks: false, accessLevel: AccessLevels.LOGGED_OUT}
            ],
        }),
        methods: {
            async logout() {
                const res = await apiLogout();

                if (res)
                {
                    localStorage.removeItem('jwt_token');
                    this.$store.dispatch('user/logout');
                    this.$store.dispatch('setLoginPreviousRoute', null);
                    this.$router.push({ name: 'login'});
                }
            },
            isNavItemAccessible(navItem)
            {
                let isAccessible = false;

                switch(navItem.accessLevel)
                {
                    case AccessLevels.LOGGED_OUT:
                        if (!this.isLoggedIn)
                            isAccessible = true;
                        break;
                    case AccessLevels.LOGGED_IN:
                        if (this.isLoggedIn)
                            isAccessible = true;
                        break;
                    case AccessLevels.MANAGER:
                        if ((UserRoles.MANAGER.value & this.user.role) === UserRoles.MANAGER.value)
                            isAccessible = true;
                        break;
                    case AccessLevels.HUMAN_RESOURCES:
                        if ((UserRoles.HUMAN_RESOURCES.value & this.user.role) === UserRoles.HUMAN_RESOURCES.value)
                            isAccessible = true;
                        break;
                    case AccessLevels.ADMIN:
                        if ((UserRoles.ADMIN.value & this.user.role) === UserRoles.ADMIN.value)
                            isAccessible = true;
                        break;
                    default:
                        isAccessible = true;
                        break;
                }

                return isAccessible;
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'user/isLoggedIn',
                user: 'user/user',
                isMaintenanceModeActivated: 'isMaintenanceModeActivated',
                isAppAvailable: 'isAppAvailable'
            }),
            computedNavigationItems()
            {
                let items = [],
                    me = this;

                this.navigationItems.forEach(function(navItem)
                {
                    if(me.isNavItemAccessible(navItem))
                    {
                        let newNavItem = {
                            icon: navItem.icon,
                            text: navItem.text,
                            accessLevel: navItem.accessLevel,
                        };

                        if(navItem.subLinks)
                        {
                            let accessibleSubLinks = [];

                            navItem.subLinks.forEach(function(subNavLink){
                                if(me.isNavItemAccessible(subNavLink))
                                {
                                    accessibleSubLinks.push(subNavLink);
                                }
                            });

                            newNavItem.subLinks = accessibleSubLinks;
                        }
                        else
                        {
                            newNavItem.subLinks = false;
                            newNavItem.route = navItem.route;
                        }

                        items.push(newNavItem);
                    }
                });

                return items;
            },
            formattedSessionExpirationTime()
            {
                let apiToken = localStorage.getItem('jwt_token');
                if (isNotNullOrUndefined(this.user) && isNotNullOrUndefined(apiToken))
                    return getTokenExpirationDate(apiToken).format('D.M.YYYY - H:mm') + ' Uhr';

                return '';
            },
            showMaintenanceModeIcon()
            {
                return (this.user.role & UserRoles.ADMIN.value) === UserRoles.ADMIN.value
                    && this.isAppAvailable
                    && this.isMaintenanceModeActivated;
            }
        }
    }
</script>

<style scoped>
.pulsating {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
}
</style>
